import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { displayVarsomePremiumMessage } from "../../../common/helpers/helpers";
import TextExpander from "../../../components/TextExpander";
import RenderBullet from "../../../components/atoms/RenderBullet/RenderBullet";
import { getIsUserPremium } from "../../../state/selectors/general.selectors";

const DrugsAndEvidenceStatementColumn = (props) => {
  const { drugs, drugInteractionType, evidenceStatement, isUserPremium } =
    props;
  if (isUserPremium || __IS_COMPONENTS_PORTAL__) {
    return (
      <div>
        {drugs && drugs.length > 0 && (
          <div className="tw-mb-2">
            <p className="tw-mb-1">
              <strong>Drugs</strong>
            </p>
            {drugs.map((drug, i) => {
              return (
                <div className="tw-mb-0" key={i}>
                  <RenderBullet />
                  {drug}
                </div>
              );
            })}
          </div>
        )}
        {drugInteractionType && (
          <div className="tw-mb-2">
            <p className="tw-mb-1">
              <strong>Drug interaction type</strong>
            </p>
            <div className="tw-mb-0">{drugInteractionType}</div>
          </div>
        )}
        {evidenceStatement && (
          <div>
            <p className="tw-mb-1">
              <strong>Evidence statement</strong>
            </p>
            <TextExpander text={evidenceStatement} truncate="150" />
          </div>
        )}
      </div>
    );
  }
  return displayVarsomePremiumMessage();
};

DrugsAndEvidenceStatementColumn.propTypes = {
  drugInteractionType: PropTypes.string,
  drugs: PropTypes.arrayOf(PropTypes.string),
  evidenceStatement: PropTypes.string,
  isUserPremium: PropTypes.bool,
};

DrugsAndEvidenceStatementColumn.defaultProps = {
  drugInteractionType: "",
  drugs: [],
  evidenceStatement: "",
  isUserPremium: false,
};

const mapStateToProps = (state) => {
  return {
    isUserPremium: getIsUserPremium(state),
  };
};

export default connect(mapStateToProps, {})(DrugsAndEvidenceStatementColumn);
